
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/create-story",
      function () {
        return require("private-next-pages/create-story.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/create-story"])
      });
    }
  